import { instance } from './index';

// 리포트 목록 _ 유저 _ 매체별
function bookingMediaList(id, dayID) {
  return instance.get(`api/bookings/medias/${id}/days/${dayID}`);
}

export { bookingMediaList };
